import { StrictMode } from 'react';
import * as ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { initBrowserMonitoring } from '@zeptonow/hawkeye';
import {
  APP_ENVIRONMENT,
  APP_NAME,
  APP_VERSION,
} from '@hrms/common/constant/global';

import App from './app/app';

import '@zeptonow/zui/styles/zui.css';
import './styles.css';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement,
);

initBrowserMonitoring({
  appConfig: {
    appName: APP_NAME,
    appVersion: APP_VERSION || 'unknown',
    environment: APP_ENVIRONMENT === 'production' ? 'prod' : 'qa',
  },
});

root.render(
  <StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
